import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CheckCircle2, Users } from "lucide-react";

import { CREAM, GREEN, INK } from "../components/tournament/PublicParts";
import { useAuth } from "../contexts/AuthContext";
import { claims } from "../lib/tournamentApi";

/** Post-tournament "Claim your team" landing. */
export default function ClaimTeam() {
  const { token } = useParams();
  const { user, switchRole } = useAuth();
  const nav = useNavigate();
  const [view, setView] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);

  useEffect(() => { claims.view(token).then(setView).catch((e) => setError(e.message)); }, [token]);

  function goAuth(path) {
    sessionStorage.setItem("chalkos.afterLogin", `/claim/${token}`);
    nav(path);
  }
  async function claim() {
    setBusy(true);
    try {
      const r = await claims.accept(token);
      localStorage.setItem("chalkos.activeTeam", r.team_id);
      if (r.switch_to_coach) await switchRole("coach");
      setDone(r);
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  }
  return (
    <div data-testid="claim-page" style={{ background: INK, color: CREAM, minHeight: "100vh", padding: "48px 22px", fontFamily: "system-ui, sans-serif" }}>
      <div style={{ maxWidth: 440, margin: "0 auto", textAlign: "center" }}>
        {error && <div data-testid="claim-error" style={{ fontSize: 15, lineHeight: 1.5, marginBottom: 16 }}>{error}</div>}
        {view && (
          <>
            <div style={{ fontSize: 12, letterSpacing: "0.12em", textTransform: "uppercase", opacity: 0.7 }}>{view.tournament_name}</div>
            <h1 data-testid="claim-team-name" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 52, margin: "8px 0 6px", lineHeight: 1 }}>{view.team_name}</h1>
            <div data-testid="claim-carryover" style={{ fontSize: 14, opacity: 0.8, lineHeight: 1.5 }}>
              {view.team_type === "adult" && view.roster_count > 0
                ? `Your team name, sport and ${view.roster_count} player${view.roster_count > 1 ? "s" : ""} come with you.`
                : "Your team name and sport come with you. Add your roster after you claim."}
            </div>
            {done || view.status === "claimed" ? (
              <div data-testid="claim-done" style={{ marginTop: 32 }}>
                <CheckCircle2 size={64} color="#4db87a" aria-hidden="true" />
                <div style={{ fontSize: 18, fontWeight: 700, marginTop: 8 }}>{done ? "Team claimed." : "This team has already been claimed."}</div>
                {done && <button data-testid="claim-open-team" onClick={() => { window.location.href = "/app/roster"; }} style={primary}>Open my team</button>}
              </div>
            ) : user ? (
              <button data-testid="claim-accept" disabled={busy} onClick={claim} style={primary}>
                <Users size={16} aria-hidden="true" /> {busy ? "Claiming…" : `Claim ${view.team_name}`}</button>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 28 }}>
                <button data-testid="claim-signup" onClick={() => goAuth("/signup")} style={primary}>Create a free account</button>
                <button data-testid="claim-login" onClick={() => goAuth("/login")} style={secondary}>I already have an account</button>
              </div>
            )}
          </>
        )}
        <div style={{ marginTop: 40, fontSize: 11, opacity: 0.5, letterSpacing: "0.12em" }}>CHALKOS</div>
      </div>
    </div>
  );
}

const primary = { display: "inline-flex", gap: 8, alignItems: "center", justifyContent: "center", marginTop: 24, background: GREEN, color: "#fff",
                  border: "none", borderRadius: 999, padding: "14px 24px", fontWeight: 800, fontSize: 15, cursor: "pointer" };
const secondary = { ...primary, marginTop: 0, background: "transparent", color: CREAM, border: "0.5px solid rgba(245,240,232,0.4)" };
